import { configureStore } from "@reduxjs/toolkit";
import convert from "./slices/convert/convertSlice";
import market from "./slices/market/marketSlice";
import notification from "./slices/notification/notificationSlice";
import portfolio from "./slices/portfolio/portfolioSlice";
import trade from "./slices/trade/tradeSlice";
import user from "./slices/user/userSlice";
import wallet from "./slices/wallet/walletSlice";
import investment from "./slices/investment/investmentSlice";

export const store = configureStore({
  reducer: { notification, user, convert, trade, portfolio, wallet, market, investment },

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});
